import React from 'react';

import * as analytics from 'analytics/Analytics';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import TFIActions from 'notebook/tfi/TFIActions';
import {TFIAccount} from 'notebook/tfi/TFIConstants';
import TFIUtil from 'notebook/tfi/TFIUtil';

import TFIAccountIcon from './TFIAccountIcon';

interface TFIAccountItemProps {
  account: TFIAccount;
  isChild: boolean;
}

export default class TFIAccountItem extends React.Component<TFIAccountItemProps> {
  private handleOpen = (): void => {
    // Accounts use the same ID for both folder and account IDs
    TFIActions.listFolder(this.props.account.id, this.props.account.id);
    analytics.track('tfi', 'listed_folder', {accountType: this.props.account.accountType});
  };

  render(): JSX.Element {
    return (
      <SidepanelItem
        icon={<TFIAccountIcon accountType={this.props.account.accountType} />}
        isCompact={false}
        title={{text: TFIUtil.readableAccountType(this.props.account.accountType)}}
        subTitle={this.props.account.name}
        onClick={this.handleOpen}
        isExpandable={false}
        isChild={this.props.isChild}
      />
    );
  }
}
